// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wT8X","comment":"styles_comment__2PlAr"};